// @ts-nocheck

import { Activity } from "@/types/activity";
import "./styles.scss";
import { FaChevronDown } from "react-icons/fa";
import {
  LevelEight,
  LevelFive,
  LevelFour,
  LevelNine,
  LevelOne,
  LevelSeven,
  LevelSix,
  LevelTen,
  LevelThree,
  LevelTwo,
  Padlock,
} from "../level-icon/Level-Icons-unzipped";
import React from "react";
import truncateString from "@/utils/truncateString";

interface ActivityListCardProp {
  activity: Activity;
  onClick: () => void;
}

type LevelIconKey =
  | "levelOne"
  | "levelTwo"
  | "levelThree"
  | "levelFour"
  | "levelFive"
  | "levelSix"
  | "levelSeven"
  | "levelEight"
  | "levelNine"
  | "levelTen";

interface ActivityWithTypedIcon extends Activity {
  icon: LevelIconKey;
}

export default function ActivityListCard({
  activity,
  onClick,
}: ActivityListCardProp) {
  const LevelComponents: Record<string, React.FC> = {
    levelOne: LevelOne,
    levelTwo: LevelTwo,
    levelThree: LevelThree,
    levelFour: LevelFour,
    levelFive: LevelFive,
    levelSix: LevelSix,
    levelSeven: LevelSeven,
    levelEight: LevelEight,
    levelNine: LevelNine,
    levelTen: LevelTen,
  };

  // Retrieve the appropriate level icon component
  const LevelIcon: React.FC =
    LevelComponents[activity.icon as LevelIconKey] ?? LevelOne;

  return (
    <header
      role="button"
      className="activity-list-card"
      style={{
        backgroundColor: activity.locked ? "#e1e8ed" : "",
      }}
      onClick={activity.locked ? () => {} : onClick}
    >
      <div className="activity-list-card-content">
        <div>
          <LevelIcon />
        </div>
        <div className="activity-list-card-details">
          <h3 className="activity-list-card-title">
            {truncateString(activity.title, 60)}
          </h3>
          <p className="activity-list-card-lessons">
            {activity?.completedLessons}/{activity?.totalLessons ?? 0} Lessons
          </p>
        </div>
      </div>
      {activity.locked ? (
        <Padlock />
      ) : (
        <FaChevronDown size={24} className="activity-list-card-chevron" />
      )}
    </header>
  );
}
